import React, { useEffect } from 'react'
import useAxios from 'axios-hooks'
import { FormattedMessage, useIntl } from 'react-intl'
import { Codesandbox } from 'react-feather'
import { toast } from 'react-toastify'
import { lowerCase } from 'lodash'

import BreadcrumbHeader from '~/components/BreadcrumbHeader'
import TutorialFallback from '~/assets/img/pages/tutorial-fallback.png'
import { HubWrapper } from './styles'
import { MODULES_DATA } from '~/constants/tutorialModules'
import { TutorialLoading } from './components/loading'

const TutorialHub = () => {
  const intl = useIntl()
  const [{ loading, error, data }] = useAxios({
    url: '/tutorial/hub',
    method: 'GET',
  })

  useEffect(() => {
    if (!error) return
    toast.error(intl.formatMessage({ id: 'Failed to fetch tutorials' }))
  }, [error])

  return (
    <div>
      <BreadcrumbHeader path={[{ name: 'Help Center' }]} />
      {loading ? (
        <TutorialLoading />
      ) : (
        <HubWrapper>
          <div>
            <h2>
              <FormattedMessage id="Last tutorials" />
            </h2>
            <div className="tutorial-row">
              {data?.tutorials?.map(tutorial => (
                <a
                  key={tutorial.id}
                  className="tutorial-card"
                  href={`/tutorial/${tutorial.id}`}
                >
                  {tutorial?.image ? (
                    <img src={tutorial.image} alt="" />
                  ) : (
                    <img src={TutorialFallback} alt="" />
                  )}
                  <div className="tutorial-info">
                    <div>
                      <span className="tutorial-submodule">
                        <FormattedMessage
                          id={
                            MODULES_DATA[tutorial.module]?.submodules?.[
                              tutorial.submodule
                            ] || 'Unknown'
                          }
                        />
                      </span>
                    </div>
                    <h3 className="tutorial-title">{tutorial.title}</h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
          <div>
            <h2>
              <FormattedMessage id="Explore by modules" />
            </h2>
            <div className="module-grid">
              {data?.modules?.map(module => (
                <a
                  className="module-card"
                  key={module}
                  href={`/tutorial/module/${lowerCase(module)}`}
                >
                  <div className="module-icon">
                    {MODULES_DATA[module]?.icon ? (
                      MODULES_DATA[module].icon
                    ) : (
                      <Codesandbox color="#fff" />
                    )}
                  </div>
                  <div className="module-title">
                    <FormattedMessage
                      id={MODULES_DATA[module]?.name || 'Module'}
                    />
                  </div>
                  <div className="module-action">
                    <FormattedMessage id="Watch tutorials" />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </HubWrapper>
      )}
    </div>
  )
}

export default TutorialHub
